import { Fragment, useContext, useMemo, useState, type ReactNode } from "react";
import { Link } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/base/breadcrumb";
import {
  BreadcrumbsContext,
  type BreadcrumbEntry,
} from "@/presentation/layout/breadcrumbs_context";

export function BreadcrumbsProvider({ children }: { children: ReactNode }) {
  const [items, setItems] = useState<BreadcrumbEntry[]>([]);
  const value = useMemo(() => ({ items, setItems }), [items]);
  return (
    <BreadcrumbsContext.Provider value={value}>
      {children}
    </BreadcrumbsContext.Provider>
  );
}

/** Renders the current trail in the layout header, or "Admin Console" when no page has set one. */
export function HeaderBreadcrumbs() {
  const items = useContext(BreadcrumbsContext)?.items ?? [];

  if (items.length === 0) {
    return (
      <span className="text-muted-foreground text-sm font-medium">
        Admin Console
      </span>
    );
  }

  return (
    <Breadcrumb>
      <BreadcrumbList>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <Fragment key={`${item.label}-${index}`}>
              <BreadcrumbItem>
                {isLast ? (
                  <BreadcrumbPage>{item.label}</BreadcrumbPage>
                ) : item.to ? (
                  <BreadcrumbLink asChild>
                    <Link to={item.to}>{item.label}</Link>
                  </BreadcrumbLink>
                ) : (
                  <span>{item.label}</span>
                )}
              </BreadcrumbItem>
              {!isLast && <BreadcrumbSeparator />}
            </Fragment>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
